import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from '../../hooks/useToken';

const ModalActivarAkasiaPOS = ({
    licencias,
    akasiaPOSWebPaquetes,
    idLicencia,
    setShowModalActivarAkasiaPOS,
    showModalActivarAkasiaPOS
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const { register, reset, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            idCatCicloFacturacion: 4
        }
    });
    const [procesandoModal, setProcesandoModal] = useState(false);

    /**
     * Submit de activar
     * @param {any} data
     */
    const onSubmitActivar = data => {
        setProcesandoModal(true);
        activarLicencia(JSON.stringify(data));
    };

    /**
     * Activar licencia
     * @param {any} values
     */
    const activarLicencia = async (values) => {
        console.log(values);
        const response = await fetch("/api/licencia/activarlicencia/?id=" + idLicencia + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {

                //se actualizan unicamente los campos modificados.
                licencias.bIsPeriodoPrueba = data["table2"][0].bIsPeriodoPrueba;
                licencias.dUpdatedDate = data["table2"][0].dUpdatedDate;
                licencias.vUpdatedUser = data["table2"][0].vUpdatedUser;
                licencias.dInicioLicenciaUso = data["table2"][0].dInicioLicenciaUso;
                licencias.dDiasTranscurridos = data["table2"][0].dDiasTranscurridos;
                licencias.dFinLicenciaUso = data["table2"][0].dFinLicenciaUso;
                licencias.dDiasFaltantes = data["table2"][0].dDiasFaltantes;
                licencias.idCatCicloFacturacion = data["table2"][0].idCatCicloFacturacion;
                licencias.vLatLon = data["table2"][0].vLatLon;
                licencias.vConfiguracion = data["table2"][0].vConfiguracion;

                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActivarAkasiaPOS(false);
        setProcesandoModal(false);
        reset();
    };



    return (
        showModalActivarAkasiaPOS &&
        <Modal
            show={showModalActivarAkasiaPOS}
            onHide={() => setShowModalActivarAkasiaPOS(false)}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <Form noValidate onSubmit={handleSubmit(onSubmitActivar)}>
                <Modal.Header>
                    <Modal.Title>Activar Licencia {licencias.vDescripcionTipo}</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalActivarAkasiaPOS(false); reset() }} />

                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Verifica y completa la siguiente informaci&oacute;n para activar la licencia. Es necesario que se seleccione el paquete con el que se activará la licencia.
                            <hr></hr>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Fecha Inicio</Form.Label>

                                <Form.Control
                                    type="date"
                                    {...register("dInicioLicenciaUso",
                                        {
                                            required: true
                                        })
                                    }
                                    isInvalid={!!errors.dInicioLicenciaUso} />

                                <Form.Control.Feedback type="invalid">
                                    {errors.dInicioLicenciaUso && errors.dInicioLicenciaUso.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={9}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Paquete</Form.Label>
                                <Form.Select
                                    aria-label="Default select"
                                    isInvalid={!!errors.vCodigoPaquete}
                                    {...register("vCodigoPaquete",
                                        {
                                            required: "Es obligatorio seleccionar un paquete"
                                        })
                                    }
                                >
                                    <option value="">Selecciona un paquete</option>
                                    {akasiaPOSWebPaquetes.map((paquete, index) => {
                                        return (
                                            <option key={index} value={paquete.vCodigoPaquete}>
                                                {paquete.vDescripcionPaquete}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.vCodigoPaquete?.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>

                            <>
                                <Form.Group className="mb-3" >
                                    <Form.Label>vLatLon <a href="https://www.google.com.mx/maps" rel="noreferrer" target="_blank">Abrir Google Maps</a></Form.Label>
                                    <Form.Control
                                        onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                        type="text"
                                        autoComplete="off"
                                        defaultValue={licencias.vLatLon}
                                        placeholder="vLatLon"
                                        isInvalid={!!errors.vLatLon}
                                        {...register("vLatLon",
                                            {
                                                required: 'El vLatLon es requerido',
                                                pattern: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
                                            })
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vLatLon && errors.vLatLon.message}
                                    </Form.Control.Feedback>
                                </Form.Group>

                            </>

                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalActivarAkasiaPOS(false); reset() }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="submit" variant='success' >A C T I V A R</Button>}
                </Modal.Footer>
            </Form>
        </Modal>

    )
}

ModalActivarAkasiaPOS.propTypes = {

    idLicencia: PropTypes.string,
    licencias: PropTypes.object,
    setShowModalActivarAkasiaPOS: PropTypes.func,
    akasiaPOSWebPaquetes: PropTypes.array,
    showModalActivarAkasiaPOS: PropTypes.bool,
};

export default ModalActivarAkasiaPOS;

